/**
 * @summary Accordion using the WAI-ARIA disclosure pattern.
 * @see https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/
 *
 * WARNING: This file is duplicated across themes/default, themes/ewrb, and themes/iaa.
 * Changes made here must be applied to all three copies to avoid drift.
 */
(function(factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
      define(['jquery'], factory);
  } else if (typeof exports !== 'undefined') {
      module.exports = factory(require('jquery'));
  } else {
      factory(window.jQuery);
  }
}(function($) {
  'use strict';

  var defaultConfig = {
      headersSelector: '.js-accordion__header',
      panelsSelector: '.js-accordion__panel',
      buttonsSelector: 'button.js-accordion__header',
      buttonsGeneratedContent: 'text',
      button: $('<button></button>', {
          class: 'js-accordion__header',
          type: 'button'
      }),
      buttonSuffixId: '_tab',
      multiselectable: true,
      prefixClass: 'accordion',
      headerSuffixClass: '__title',
      buttonSuffixClass: '__header',
      panelSuffixClass: '__panel',
      direction: 'ltr',
      accordionPrefixId: 'accordion'
  };

  var Accordion = function($el, options) {
      this.options = $.extend({}, defaultConfig, options);

      this.$wrapper = $el;
      this.$panels = $(this.options.panelsSelector, this.$wrapper);

      this.initAttributes();
      this.initEvents();
  };

  Accordion.prototype.initAttributes = function() {
      this.$wrapper.addClass(this.options.prefixClass);

      // id generated if not present
      if (!this.$wrapper.attr('id')) {
          var index_lisible = Math.random().toString(32).slice(2, 12);
          this.$wrapper.attr('id', this.options.accordionPrefixId + '-' + index_lisible);
      }

      this.$panels.each($.proxy(function(index, el) {
          var $panel = $(el);
          var $header = $(this.options.headersSelector, $panel);
          var $button = this.options.buttonsGeneratedContent === 'html' ? this.options.button.clone().html($header.html()) : this.options.button.clone().text($header.text());

          $header.addClass(this.options.prefixClass + this.options.headerSuffixClass);
          $panel.before($button);

          var panelId = $panel.attr('id') || this.$wrapper.attr('id') + '-' + index;
          var buttonId = panelId + this.options.buttonSuffixId;

          $button.attr({
              'aria-controls': panelId,
              'aria-expanded': 'false',
              'id': buttonId
          }).addClass(this.options.prefixClass + this.options.buttonSuffixClass);

          $panel.attr({
              'aria-labelledby': buttonId,
              'id': panelId
          }).prop('hidden', true)
            .addClass(this.options.prefixClass + this.options.panelSuffixClass);

          // if opened by default
          if ($panel.attr('data-accordion-opened') === 'true') {
              $button.attr({
                  'aria-expanded': 'true',
                  'data-accordion-opened': null
              });

              $panel.prop('hidden', false);
          }


      }, this));

      this.$buttons = $(this.options.buttonsSelector, this.$wrapper);
  };

  Accordion.prototype.initEvents = function() {
      this.$wrapper.on('click', this.options.buttonsSelector, $.proxy(this.clickButtonEventHandler, this));

      this.$wrapper.on('keydown', this.options.buttonsSelector, $.proxy(this.keydownButtonEventHandler, this));
  };

  Accordion.prototype.clickButtonEventHandler = function(e) {
      var $target = $(e.target);
      var $button = $target.is('button') ? $target : $target.closest('button');
      var $panel = $('#' + $button.attr('aria-controls'));

      // opened or closed?
      if ($button.attr('aria-expanded') === 'false') { // closed
          $button.attr('aria-expanded', 'true');
          $panel.prop('hidden', false);
      } else { // opened
          $button.attr('aria-expanded', 'false');
          $panel.prop('hidden', true);
      }

      if (this.options.multiselectable === false) {
          this.$panels.not($panel).prop('hidden', true);
          this.$buttons.not($button).attr('aria-expanded', 'false');
      }

      setTimeout(function() {
          $button.focus();
      }, 0);

      e.stopPropagation();
      e.preventDefault();
  };

  Accordion.prototype.keydownButtonEventHandler = function(e) {
      var $target = $(e.target);
      var $button = $target.is('button') ? $target : $target.closest('button');
      var $firstButton = this.$buttons.first();
      var $lastButton = this.$buttons.last();
      var index = this.$buttons.index($button);

      $target = null;

      var k = this.options.direction === 'ltr' ? {
          prev: [38, 37], // up & left
          next: [40, 39], // down & right
          first: 36, // home
          last: 35 // end
      } : {
          prev: [38, 39], // up & left
          next: [40, 37], // down & right
          first: 36, // home
          last: 35 // end
      };

      var allKeyCode = [].concat(k.prev, k.next, k.first, k.last);

      if ($.inArray(e.keyCode, allKeyCode) >= 0 && !e.ctrlKey) {
          if (e.keyCode === 36) {
              $target = $firstButton;
          }
          // strike end in the tab => last tab
          else if (e.keyCode === 35) {
              $target = $lastButton;
          }
          // strike up or left in the tab => previous tab
          else if ($.inArray(e.keyCode, k.prev) >= 0) {
              // if we are on first one, activate last
              $target = $button.is($firstButton) ? $lastButton : this.$buttons.eq(index - 1);
          }
          // strike down or right in the tab => next tab
          else if ($.inArray(e.keyCode, k.next) >= 0) {
              // if we are on last one, activate first
              $target = $button.is($lastButton) ? $firstButton : this.$buttons.eq(index + 1);
          }

          if ($target !== null) {
              this.goToHeader($target);
          }

          e.preventDefault();
      }
  };

  Accordion.prototype.goToHeader = function($target) {
      if ($target.length !== 1) {
          return;
      }

      setTimeout(function() {
          $target.focus();
      }, 0);
  };


  var PLUGIN = 'accordion';

  $.fn[PLUGIN] = function(params) {
      var options = $.extend({}, $.fn[PLUGIN].defaults, params);


      return this.each(function() {
          var $el = $(this);

          var specificOptions = {
              multiselectable: $el.attr('data-accordion-multiselectable') === 'none' ? false : options.multiselectable,
              prefixClass: typeof($el.attr('data-accordion-prefix-classes')) !== 'undefined' ? $el.attr('data-accordion-prefix-classes') : options.prefixClass,
              buttonsGeneratedContent: typeof($el.attr('data-accordion-button-generated-content')) !== 'undefined' ? $el.attr('data-accordion-button-generated-content') : options.buttonsGeneratedContent,
              direction: $el.closest('[dir="rtl"]').length > 0 ? 'rtl' : options.direction
          };
          specificOptions = $.extend({}, options, specificOptions);

          $el.data[PLUGIN] = new Accordion($el, specificOptions);
      });
  };

  $.fn[PLUGIN].defaults = defaultConfig;

}));